"use client";
import React from "react";
import Image from "next/image";
import Images from "../assets/assets";

// Proper type definition
type FrameItem = {
  icon: any; // or better: import type { StaticImageData } from "next/image";
  title: string;
  description: string;
};

interface AIFrameWorkProps {
  title: React.ReactNode;
  description: string;
  subtitle: string;
  frameWorkArray: FrameItem[];
}

const AiFrameworks = ({
  title,
  description,
  subtitle,
  frameWorkArray,
}: AIFrameWorkProps) => {
  return (
    <section className="relative w-full py-[100px] px-[5%] mx-auto max-w-[5000px]">
      <Image
        src={Images?.serviceBg}
        alt="services background"
        fill
        sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
        className="object-cover -z-10"
      />

      <div className="w-full max-w-[2500px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-[60px] items-start justify-between">
          {/* Left Column - Title and Description */}
          <div className="w-full lg:w-[830px] flex flex-col gap-[34px] relative lg:sticky lg:top-[10px]">
            <div className="flex flex-col gap-[30px]">
              <span className="text-white text-[16px] font-medium uppercase tracking-wider">
                {subtitle}
              </span>
              <h2 className="text-white text-[clamp(1.875rem,0.5447rem+2.7714vw,4.875rem)] font-medium clash-font leading-[120%]">
                {title}
              </h2>
              <p className="text-[#949596] text-[clamp(0.9375rem,0.4664rem+0.9815vw,2rem)] font-normal leading-[160%]">
                {description}
              </p>
            </div>
          </div>

          {/* Right Column - Framework Cards */}
          <div className="w-full lg:w-[830px] flex flex-col gap-[60px] md:gap-[30px]">
            {frameWorkArray?.map((framework, index) => (
              <div key={index} className="flex flex-col gap-[15px]">
                <div className="flex flex-col gap-[15px]">
                  <div className="w-[66px] h-[66px] flex items-center justify-center">
                    <Image
                      src={framework.icon}
                      alt={framework.title}
                      width={66}
                      height={66}
                      className="w-full h-full object-contain"
                      sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
                    />
                  </div>
                  <h3 className="text-white text-[clamp(1.25rem,0.7512rem+1.0393vw,2.375rem)] font-medium clash-font leading-[120%]">
                    {framework.title}
                  </h3>
                  <p
                    className="text-[#949596] text-[18px] font-normal leading-[140%]"
                    dangerouslySetInnerHTML={{
                      __html: framework.description ?? "",
                    }}
                  />
                </div>
                {index < frameWorkArray.length - 1 && (
                  <div className="w-full h-[1px] bg-white opacity-20"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AiFrameworks;
